import React from 'react';
import './Home.scss';

import Cards from './Cards/Cards';
import HeroInformation from '../Components/HeroInformation';
import { useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

const Home = () => {
    const companyList = useSelector(({company}) => company.companies);
    const projectList = useSelector(({projects}) => projects.projects);
    const {t} = useTranslation();

    return (
        <div className={'home'}>
            <HeroInformation title={t('Home.welcomeTitle')} description={t('Home.welcomeDescription')}/>
            <Cards companyList={companyList} projectList={projectList}/>
        </div>
    );
};

export default Home;
